<template>
    <div class="vx-card">
        <!-- dialog list contact-->
        <vs-popup id="page-contact-list" title="アドレス帳" :active.sync="statusModelContacts">
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-input class="w-full" search v-model="searchContact" placeholder="メールアドレスまたは氏名を入力" />
                </div>
                <div class="sm:w-1/2 w-full flex">
                    <div class="sm:w-1/2 w-full ml-3">
                        <vs-button icon="search" @click="onSearch()" color="primary" class="sm:w-10/12" style="padding: 8px; height: 37px">検索</vs-button>
                    </div>
                    <div class="sm:w-1/2 w-full">
                        <vs-button @click="applyListMail" color="success" class="sm:w-10/12" style="padding: 6px; height: 37px" :disabled="disableApplyButton">送信先に追加</vs-button>
                    </div>
                    <div class="sm:w-1/2 w-full">
                        <vs-button @click="createContact" color="success" class="sm:w-10/12" style="padding: 8px; height: 37px">新規登録</vs-button>
                    </div>
                </div>
            </div>
            <div class="vx-row mt-5">
                <ag-grid-vue
                    id="myGridContact"
                    :components="components"
                    :gridOptions="gridOptionsContact"
                    class="ag-theme-material w-100 my-4 ag-grid-table database"
                    :columnDefs="columnDefsContact"
                    :defaultColDef="defaultColDef"
                    :rowData="listContactConditionsComputed"
                    rowSelection="multiple"
                    colResizeDefault="shift"
                    :animateRows="true"
                    :pagination="true"
                    :paginationPageSize="paginationPageSize"
                    :suppressPaginationPanel="true"
                    :domLayout="domLayout"
                    @grid-ready="onGridReadyContact"
                    @selection-changed="onSelectionChangedContacts"
                    :overlayNoRowsTemplate="noRowsTemplate"
                    :detailRowAutoHeight="true"
                ></ag-grid-vue>
            </div>
            <div style="position: relative">
                    <!-- ITEMS PER PAGE -->
                    <div>
                        <div class="flex items-center justify-between">
                            <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                        </div>
                    </div>
                    <div class="vx-row flex justify-center">
                        <div>
                            <vs-pagination
                            v-if="listContactConditionsComputed.length > 0"
                            :total="pagination.totalPage"
                            :max="7"
                            v-model="pagination.currentPage"
                            class="pt-5"
                        />
                        </div>
                    </div>
                </div>
        </vs-popup>
        <ContactDetail
            v-show="activeModelContactDetail"
            :activeModelContactDetail="activeModelContactDetail" 
            :contactShow="contactShow" 
            :typeModalContact="typeModal_Contact"
            v-on:cancelPopupContactDetail="cancelPopupContactDetail"
        />
        <PopupConfirm
            :activeModelCloseTab="activeModelCloseTab"
            modelTitle="メールアドレスの削除"
            buttonTitleYes="はい"
            eventEmitYes="ConfirmDeleteYes"
            buttonTitleNo="キャンセル"
            eventEmitNo="ConfirmDeleteNo"
            v-on:ConfirmDeleteYes="ConfirmDeleteYes"
            v-on:ConfirmDeleteNo="ConfirmDeleteNo"
        >
            <div slot="content">
                <div class="font-medium" style="line-break: anywhere;">【{{ this.objDelete.mail_address }}: {{ this.objDelete.name }}】を削除します。よろしいでしょうか？</div>
            </div>
        </PopupConfirm>
        <!-- <PopupConfirm
            :activeModelCloseTab="activeModelCloseTab2"
            modelTitle="メールアドレスは送信先に追加しますか？"
            buttonTitleYes="はい"
            eventEmitYes="ConfirmApplyYes"
            buttonTitleNo="キャンセル"
            eventEmitNo="ConfirmApplyNo"
            v-on:ConfirmApplyYes="ConfirmApplyYes"
            v-on:ConfirmApplyNo="ConfirmApplyNo"
        >
            <div slot="content">
                <div class="font-medium">選択したメールアドレス：</div><br/>
                <p style="line-break: anywhere;" v-for="(addressEmaill, index) in listMailSelected">{{ (index + 1) + ', ' + addressEmaill }}</p>
            </div>
        </PopupConfirm> -->
    </div>
</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import EventBus from "../EventBus";
// Cell Renderer
import CellRendererActionsButton from '@/components/cell-renderer/CellRendererActionsButton.vue';
import ContactDetail from '@/components/ContactDetail.vue';
import PopupConfirm from '@/components/PopupConfirm.vue';

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActionsButton,
        ContactDetail,
        PopupConfirm
    },
    props: {
        activeModelContacts: {
            required: true,
            type: Boolean,
        },
        typeModalContact:{
            type: String
        }
    },
    data() {
        return {
            searchContact: '',
            statusModelContacts: false,
            activeModelContactDetail: false,
            contactShow: {},
            activeModelCloseTab: false,
            activeModelCloseTab2: false,
            idContactDelete: null,
            objDelete: {},
            listMailSelected: [],
            startRow: 0,
            endRow: 0,
            pagination: {
                totalPage: 0,
                currentPage: 1,
                limit: 10,
                totalItem: 0,
                from: 1,
                to: 10
            },
            isCreated: true,
            disableApplyButton: true,
            // AgGrid
            gridApiContact: null,
            gridOptionsContact: {
                onGridSizeChanged: () => {
                this.gridApiContact.sizeColumnsToFit();
                },
            },
            domLayout: "autoHeight",
            noRowsTemplate: "<span>データがありません</span>",
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true,
                sortingOrder: ['asc', 'desc'],
            },
            columnDefsContact: [
                {
                    width: 70,
                    filter: true,
                    checkboxSelection: (params) => {
                        return true;
                    },
                    headerCheckboxSelectionFilteredOnly: true,
                    headerCheckboxSelection: true,
                    cellRendererParams: {
                        notSetup: true,
                    },
                    suppressMovable: true,
                },
                {
                    headerName: "メールアドレス",
                    field: "mail_address",
                    width: 400,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "氏名",
                    field: "name",
                    width: 300,
                    unSortIcon: true,
                    suppressMovable: true,
                },
                {
                    headerName: "",
                    field: "action",
                    width: 300,
                    cellRendererFramework: Vue.extend(CellRendererActionsButton),
                    unSortIcon: false,
                    suppressMovable: true,
                    resizable: true,
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActionsButton,
            },
            typeModal_Contact:'',
        }
    },
    computed: {
        ...mapGetters({
            listContactConditionsComputed: 'contact/getContactListConditions'
        }),
        listContactSelect() {
            let listContactSelect = []
            listContactSelect.push({ label: "..." , name: "" })
            this.listContactConditionsComputed.forEach(element => {
                listContactSelect.push({label: element.mail_address , value: element.name});
            });
            return listContactSelect
        },
        paginationPageSize () {
            if (this.gridApiContact) return this.gridApiContact.paginationGetPageSize()
            else return 10
        },
        totalPages () {
            if (this.gridApiContact) return this.gridApiContact.paginationGetTotalPages()
            else return 0
        },
        totalRow(){
            return parseInt(this.pagination.totalItem)
        },
    },
    methods: {
        ...mapActions({
            fetchContactList: 'contact/fetchContactList',
            fetchContactListConditions: 'contact/fetchContactListConditions',
            deleteContact: 'contact/delete',
        }),
        createContact() {
            this.contactShow = {}
            this.statusModelContacts = false
            this.activeModelContactDetail = true
            this.typeModal_Contact = this.typeModalContact;
        },
        cancelPopupContactDetail(val,type_contact) {
            this.statusModelContacts = true
            this.activeModelContactDetail = false
            if(val) {
                this.fetchContactList()
                this.onSearch()
                this.listMailSelected = [];
            }
            this.typeModal_Contact = type_contact;
        },
        onGridReadyContact(params) {
            this.gridApiContact = params.api;
            this.columnApiRule = params.columnApi;
        },
        onSelectionChangedContacts(){
            this.listMailSelected = []
            let selectedStates = this.gridApiContact.getSelectedRows();
            selectedStates.forEach((contact) => {
                this.listMailSelected.push(contact.name +' <'+ contact.mail_address +'>')
            })
            this.disableApplyButton = this.listMailSelected.length > 0 ? false : true 
        },
        async paginationPage(value) {
            if(!this.isCreated) {
                this.pagination.currentPage = value
                await this.onSearch(false) 
            }
        },
        async onSearch(resetPage = true) {
            this.listMailSelected = [];
            this.disableApplyButton = true;
            let page
            if(!resetPage) {
                page = this.pagination.currentPage
            } else {
                page = 1
            }
            let params = {
                page: page,
                limit: this.pagination.limit,
                contact_search: this.searchContact,
            }
            
            var data = await this.fetchContactListConditions(params)
            this.pagination.totalItem = data.total;
            this.pagination.totalPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.limit = data.per_page;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
        async ConfirmDeleteYes() {
            await this.deleteContact(this.idContactDelete)
            this.fetchContactList()
            this.onSearch()
            this.listMailSelected = []
            this.activeModelCloseTab = false
            this.statusModelContacts = true
        },
        ConfirmDeleteNo() {
            this.activeModelCloseTab = false
            this.statusModelContacts = true
        },
        applyListMail() {
            let typeContact = this.typeModalContact || this.typeModal_Contact;
            this.statusModelContacts = false
            this.activeModelCloseTab2 = true
            EventBus.$emit('applyContactsTo', this.listMailSelected, typeContact)
            this.listMailSelected = [];
        },
        // ConfirmApplyYes() {
        //     this.statusModelContacts = false
        //     this.activeModelCloseTab2 = false
        //     EventBus.$emit('applyContactsTo', this.listMailSelected)
        // },
        ConfirmApplyNo() {
            this.statusModelContacts = true
            this.activeModelCloseTab2 = false
        },
    },
    mounted() {
        this.gridApiContact = this.gridOptionsContact.api
        EventBus.$on("editRecord", (obj) => {
            this.contactShow = obj
            this.statusModelContacts = false
            this.activeModelContactDetail = true
        });
        EventBus.$on("deleteRecord", (obj) => {
            this.statusModelContacts = false
            this.activeModelCloseTab = true
            this.idContactDelete = obj.id
            this.objDelete = obj
        });
        EventBus.$on("disableModelContactDetail", () => {
            this.activeModelContactDetail = false
        });
        EventBus.$on("disableModelPopupConfirm", () => {
            this.activeModelCloseTab = false
            this.activeModelCloseTab2 = false
        });
        EventBus.$on("contactShowObjectEmpty", () => {
            this.contactShow = {}
        });
    },
    created() {
        this.onSearch()
        this.isCreated = false
    },
    watch: {
        activeModelContacts() {
            this.onSearch();
            this.$nextTick(() => {
                this.statusModelContacts = this.activeModelContacts
            });
        },
        statusModelContacts(val) {
            this.$nextTick(() => {
                if(val == false) {
                    EventBus.$emit('disableModelContacts')
                    this.listMailSelected = [];
                } else {
                    this.disableApplyButton = this.listMailSelected.length > 0 ? false : true
                }
            });
        },
        'pagination.currentPage':{
            deep: true,
            immediate: true,
            handler: function(val){
                if(!this.isCreated) this.paginationPage(val)
            }
        },
    },
    updated() {
        this.$nextTick(()=>{
        if(!this.$store.state.loading && this.listContactConditionsComputed.length > 0){
            this.startRow = this.pagination.currentPage * this.pagination.limit - this.pagination.limit + 1
            if(this.listContactConditionsComputed.length == this.pagination.limit) this.endRow = this.pagination.currentPage*this.pagination.limit
            else this.endRow = this.pagination.currentPage * this.pagination.limit - this.pagination.limit + + this.listContactConditionsComputed.length
        }
        else if(this.listContactConditionsComputed.length == 0) {
                this.pagination.totalItem = 0;
                this.startRow = 0
                this.endRow = 0
            }
        });
    },
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/contact.scss";
</style>
